import { __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { callback } from '../index.v0';
import { newHomeConfig } from '../newHomeConfig';
import NbbankSdk from '@ekuaibao/sdk-bridge/sdk/nbbank';
import registerAPI from '../registerAPI';
import { initializeTitle } from '../initializeTitle';
import initPlatformInfo from '../initPlatformInfo';
import registerHandler from '../registerHandler';
import { fetchHandleError } from '../FetchConfig';
import { initRoute } from '../initRoute';
import { initColors } from '../initColors';
import initLogger from '../../logger/initLogger';
initLogger();
window.__PLANTFORM__ = 'NBBANK';
function startup() {
    app.use({
        id: '@nbbank',
        onready: function () {
            addNcpcCode();
        }
    });
    callback();
}
function modifierKey(e) {
    var modifier = 0;
    if (e.metaKey) {
        modifier |= 1;
    }
    if (e.ctrlKey) {
        modifier |= 2;
    }
    if (e.altKey) {
        modifier |= 4;
    }
    if (e.shiftKey) {
        modifier |= 8;
    }
    return modifier;
}
fetchHandleError();
window.addEventListener('keydown', function (e) {
    var modifier = modifierKey(e);
    if (e.keyCode === 82 && (modifier === 1 || modifier === 2)) {
        window.location.reload();
    }
});
export var bootstrap = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                initColors();
                app.container.set('IDeviceType', 'DESKTOP');
                app.container.set('ISMessageEntry', false);
                app.sdk = app.container.get(NbbankSdk);
                registerHandler();
                return [4, app.sdk.initialize()];
            case 1:
                _a.sent();
                initRoute();
                initPlatformInfo();
                return [4, newHomeConfig()];
            case 2:
                _a.sent();
                initializeTitle();
                registerAPI();
                return [4, startup()];
            case 3:
                _a.sent();
                return [2];
        }
    });
}); };
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'beta') {
    require('../development');
}
